// @ts-nocheck
import { gql } from "@apollo/client";
import { CompanyFilter, CompanyMatchFilter } from "../types/companyFilter";
import { useCompanySearchQuery } from "./useCompanySearchQuery";
import { useWorkspaceStore } from "../../store/workspace/WorkspaceStore";

type TopProductsRecord = {
  categoryName: string;
  companyCount: number;
  productDescription: string;
  productId: number;
  productName: string;
  vendorName: string;
  vendorUrl: string;
};

type TopProductsResponse = {
  topProducts: TopProductsRecord[];
};

interface TopProductsQueryParams {
  companyFilters: CompanyFilter;
  productCategoryIds: string[];
  localizeInstalls: boolean;
  skip?: boolean;
}

const TOP_PRODUCTS_QUERY = gql`
  query topProducts(
    $opportunityGeneratorFilters: OpportunityGeneratorFilter
    $productCategoryIds: [Identifier]!
    $localizeInstalls: Boolean
    $companyMatchFile: CompanyMatchFilter
  ) {
    topProducts(
      companyFilters: $opportunityGeneratorFilters
      productCategoryIds: $productCategoryIds
      localizeInstalls: $localizeInstalls
      companyMatchFile: $companyMatchFile
    ) {
      categoryName
      companyCount
      productDescription
      productId
      productName
      vendorName
      vendorUrl
    }
  }
`;

export const useTopProductsQuery = (options: TopProductsQueryParams) => {
  const workspaceWhitespace = useWorkspaceStore(
    (state) => state.draft?.configuration?.whitespace
  );

  // Determine companyMatchFile based on opportunity type filter and whitespace config
  const companyMatchFile =
    options.companyFilters?.opportunityType &&
    workspaceWhitespace?.fileId &&
    workspaceWhitespace?.lastMatched
      ? workspaceWhitespace
      : options.companyMatchFile;

  const { loading, data } = useCompanySearchQuery<TopProductsResponse>({
    opportunityGeneratorFilters: options.companyFilters,
    localizeInstalls: options.localizeInstalls,
    productCategoryIds: options.productCategoryIds,
    query: TOP_PRODUCTS_QUERY,
    skip: options.skip || false,
    variables: {
      companyMatchFile,
    },
  });

  return {
    isLoadingTopProducts: loading,
    topProducts: data?.topProducts || [],
  };
};
